// export const v2ReactURL = "http://192.168.149.62:8080/api/v1/react";
// export const v2ReactURL = "https://sakshijadhavvasyerpcom.vyaparerp.com/api/v1/react";
// export const v2ReactURL = "https://22feb.vasyerp.in";

// export const v2ReactURL = `https://alpha.vasyerp.in/api/v1/react`;
// export const v2ReactURL = `https://alpha.vasyerp.in/api/v1/react`
export const v2ReactURL = `${window.location.origin}/api/v1/react`;
// export const v2ReactURL = `https://support.vasyerp.in/api/v1/react`;
// export const v2ReactURL = `https://sakshijadhavvasyerpcom.vyaparerp.com/api/v1/react`;

export const COUNTRY_CDN_URL = `https://cdn.vasyerp.com/assets/images/countries-flag`;
